module.exports = __webpack_public_path__ + "static/media/activate.8701685a.png";